import type { BlockExport } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { P } from "./PBlock";
import { defaultData } from "./PBlockDefaultData";
import { meta } from "./PBlockMetaData";

export const PBlock: BlockExport = {
  type: "component",
  Block: P,
  imagePreview: {
    type: "icon",
    name: "24-builder-ui-element-paragraph",
    size: 24,
  },
  defaultData,
  meta,
};
